import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiMarkdownViewerComponent } from './ui-markdown-viewer/ui-markdown-viewer.component';
import { QuillModule } from 'ngx-quill';

@NgModule({
  imports: [
    CommonModule,
    QuillModule.forRoot()
  ],
  declarations: [UiMarkdownViewerComponent],
  exports: [UiMarkdownViewerComponent]
})
export class UiMarkdownViewerModule {}
